import { useState } from 'react';

import CMSCard from '../CMSCard/CMSCard';
import GenericModalV2 from '../GenericModalV2';

import styles from './Newsletter.module.scss';

function Newsletter({ clubCard }) {
  const [openModal, setOpenModal] = useState(false);
  const sideBarText = clubCard
    ? 'Θέλεις να μην χάνεις ευκαιρία να κερζίζεις; Γράψου στο Newsletter μας!'
    : `Θέλεις να μαθαίνεις τα τελευταία νέα της ${process.env.displayName};`;
  const success = `Ευχαριστούμε για την εγγραφή σας στο Newsletter των Supermarket ${process.env.displayName}`;
  return (
    <>
      <CMSCard>
        <h5 className={styles.title}>{sideBarText}</h5>
        <form
          className={styles.group}
          action="//www.contactpigeon.com/apps/en/stem/subscribe.html/"
          method="post"
          name="form_sf_8874"
          onSubmit={() => setOpenModal(true)}
        >
          <input type="hidden" value="8874" name="gm_pid" />
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="sfemail" />
          <input
            className={styles.input}
            type="email"
            placeholder="Το email σου"
            id="sfemail"
            name="sfemail"
            required
          />
          <input type="submit" name="regme" className={styles.button} value="ΕΓΓΡΑΦΗ" />
        </form>
      </CMSCard>
      {openModal && <GenericModalV2 mainText={success} isOpen={openModal} modalLabel="Info modal" />}
    </>
  );
}

export default Newsletter;
